/**
 * Ground shake for the buffalo herd crossing the screen.
 * Intensity builds up (herd approaching), holds, then fades (herd leaving).
 * Offsets are in pixels, rotation in radians.
 */
export const SceneShakeConfig = {
    /** Phase durations (s) */
    rampUp: 1,
    sustain: 3,
    rampDown: 1,
    /** Intensity (0-1) of the first jolt, so the shake is felt right away */
    startIntensity: 0.35,
    /** Duration of a single jolt (s). Smaller = more frantic */
    stepDuration: 0.05,
    /** Max offset / rotation at full intensity */
    amplitude: { x: 3, y: 6, rotation: 0.002 },
    /** Ease of a single jolt, and of the ramp up / down curve */
    ease: "sine.inOut",
    intensityEase: "power2.in"
};

export type SceneShakeConfigType = typeof SceneShakeConfig;
